<template lang="pug">
  v-row(no-gutters)
    v-col(cols=2)
      v-select(
        :disabled="!enableExtension",
        :value="country",
        :items="codes",
        item-text="text",
        item-value="value",
        :label="extensionLabel",
        @change="$emit('update:country', $event)",
      )
    v-col(cols=10)
      v-text-field(
        :value="value",
        :rules="rules",
        type="number",
        v-bind="$attrs",
        @input="$emit('update:value', $event)",
      )
</template>

<script>
import { concat } from 'ramda';
import { codes } from '@/constant/index';

export default {
  props: {
    country: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },

    value: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },

    extensionLabel: {
      type: String,
      default: 'code',
    },

    enableExtension: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      codes: [
        {
          value: 'Singapore',
          text: codes.Singapore,
        },
        {
          value: 'Thailand',
          text: codes.Thailand,
        },
      ],
    };
  },

  computed: {
    dialCode() {
      if (this.country === 'Singapore') {
        return codes.Singapore;
      }

      // thailand country code
      return codes.Thailand;
    },

    rules() {
      const base = [v => !!v || this.$attrs.label + ' is required'];

      if (this.country === 'Singapore') {
        return concat(base, [
          v => (v && v.length === 8) || 'There should be 8 numbers',
        ]);
      }

      if (this.country === 'Thailand') {
        return concat(base, [
          v =>
            (v && (v.length === 8 || v.length === 9 || v.length === 10)) ||
            'There should be 8 to 10 numbers',
        ]);
      }

      return base;
    },
  },
};
</script>
